module.exports = __webpack_public_path__ + "assets/icon-clock-white.801d792b.svg";